export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8165.abde2600.jpg";